import { IBooking, ICalendarNote, ILodgifyBooking } from "../../../types/models";
import { useTheme } from "../../../contexts/ThemeProvider";
import moment from "moment/moment";
import styled from "styled-components";
import MonthCalendar from "./MonthCalendar";


const YearContainer = styled.div`
  margin: auto;
  padding: 0 24px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 1820px;
  gap: 4px;

  @media (max-width: 1380px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 1100px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    max-width: 600px;
  }
`;

interface BookingCalendarProps {
  year: number;
  bookings: IBooking[];
  notes: ICalendarNote[];
  externalBookings: ILodgifyBooking[];
  setNoteToEdit: any;
  setBookingToEdit: any;
  setCreateBookingDate?: any;
  setCreateNoteDate?: any;
}

const BookingsCalendar = ({ year, bookings, notes, externalBookings, setNoteToEdit, setBookingToEdit, setCreateBookingDate, setCreateNoteDate }: BookingCalendarProps) => {
  const { currentTheme } = useTheme();
  const months = moment.months();

  const ownerColors = new Map<number, string>();
  const ownerTextColors = new Map<number, string>();
  const colors = currentTheme === 'dark' ?  [
    '#5C1A1A',
    '#4A2800',
    '#0C2A4A',
    '#1E1A50',
    '#162E06',
    '#063028',
    '#4A1A08',
    '#440F24',
    '#062038',
    '#182800',
    '#220C3C',
    '#0C1E2C',
  ] : [
    '#FBDCDC',
    '#FAEEDA',
    '#E6F1FB',
    '#EEEDFE',
    '#EAF3DE',
    '#E1F5EE',
    '#FAECE7',
    '#FBEAF0',
    '#E8F4FD',
    '#F0F8DC',
    '#F3EAFA',
    '#EAF0F4',
  ];
    const textColors = currentTheme === 'dark' ?  [
    '#F5BABA',
    '#FAD09A',
    '#B5D4F4',
    '#CECBF6',
    '#c6e3a0',
    '#9FE1CB',
    '#F5C4B3',
    '#F4C0D1',
    '#C0E0FA',
    '#D0EC90',
    '#DCC0F5',
    '#B8D0E0',
  ] : [
    '#7A1F1F',
    '#412402',
    '#042C53',
    '#26215C',
    '#173404',
    '#04342C',
    '#4A1B0C',
    '#4B1528',
    '#062540',
    '#1A3000',
    '#2A1040',
    '#0E2030',
  ];

  const bookingOwnerIds = bookings.map(b => b.unit_owner?.id).filter(Boolean);
  const noteOwnerIds = notes.map((n: any) => n.owner).filter(Boolean);
  const allOwnerIds = [...bookingOwnerIds, ...noteOwnerIds];
  // @ts-ignore
  const uniqueOwnerIds: any[] = [...new Set(allOwnerIds)];

  uniqueOwnerIds.forEach((ownerId, index) => {
    ownerColors.set(ownerId, colors[index % colors.length]);
    ownerTextColors.set(ownerId, textColors[index % textColors.length]);
  });


  return (
    <YearContainer>
      {months.map((monthName, monthIndex) => (
        <MonthCalendar
          key={monthIndex}
          year={year}
          month={monthIndex}
          bookings={bookings}
          notes={notes}
          externalBookings={externalBookings}
          setNoteToEdit={setNoteToEdit}
          setBookingToEdit={setBookingToEdit}
          ownerColors={ownerColors}
          ownerTextColors={ownerTextColors}
          setCreateBookingDate={setCreateBookingDate}
          setCreateNoteDate={setCreateNoteDate}
        />
      ))}
    </YearContainer>
  );
};

export default BookingsCalendar;
